import React from 'react';
import SlateHtml from '../SlateHtml';
import { useStyles } from './styles';

export interface LegalTextProps {
  children?: string;
}

function LegalText({ children }: LegalTextProps) {
  const styles = useStyles();

  if (!children) {
    return null;
  }

  return (
    <div className={styles.legalText}>
      <SlateHtml html={children} />
    </div>
  );
}

export default LegalText;
